import { useArcadeMigrationFeatureFlag } from '../ArcadeComponentMigration/ArcadeComponentMigrationProvider'
import ArcadeStructuredContent from './ArcadeStructuredContent'
import MooncakeStructuredContent from './MooncakeStructuredContent'

/**
 * @deprecated Use ArcadeStructuredContent instead
 */
const StructuredContent = ({ children, ...props }: React.HTMLAttributes<HTMLDivElement>) => {
  const shouldUseArcadeStructuredContent = useArcadeMigrationFeatureFlag('structured-content')

  if (shouldUseArcadeStructuredContent) {
    return <ArcadeStructuredContent {...props}>{children}</ArcadeStructuredContent>
  }
  return <MooncakeStructuredContent {...props}>{children}</MooncakeStructuredContent>
}

export default StructuredContent
